<div class="intervention-header">
  <!-- Title and reference section -->
  <div class="header-main">
    <div class="title-section">
      <h1 class="intervention-title">{{ intervention.name }}</h1>

      <div class="tags-container">
        <!-- Tag pour la référence ML -->
        <p-tag
          [value]="intervention.affair.mlRef"
          severity="info"
          [rounded]="true"
        ></p-tag>

        <!-- Tag pour la source ERP -->
        <div class="erp-source-tag" *ngIf="intervention.erpSource">
          <span class="erp-source-label">Accompagnateur Rénov'</span>
          <i
            class="tll fa-logo-{{ intervention.affair.erpSource }} text-{{
              intervention.affair.erpSource
            }}"
          ></i>
        </div>

        <!-- Tag pour l'intégration Constéo -->
        <p-tag
          [value]="'Lié à Constéo: ' + (isLinkedToConsteo ? 'Oui' : 'Non')"
          [severity]="isLinkedToConsteo ? 'success' : 'danger'"
          [rounded]="true"
        ></p-tag>
      </div>
    </div>

    <!-- Status badge -->
    <div
      class="status-badge"
      *ngIf="intervention.interventionStatus"
      [style.background-color]="intervention.interventionStatus.color"
    >
      {{ intervention.interventionStatus.name }}
    </div>
  </div>

  <!-- Date and duration section -->
  <div class="date-section">
    <div class="info-items">
      <div class="info-item">
        <i class="pi pi-calendar"></i>
        <span class="date-text">{{ formattedDate }}</span>
      </div>

      <div class="info-item">
        <i class="pi pi-clock"></i>
        <span class="duration-text">Durée: {{ intervention.duration }}</span>
      </div>
    </div>
  </div>
</div>
